import { MapState } from 'types';

import { drawReducer, MapDrawAction } from './draw';
import { layersReducer, MapLayersAction } from './layers';
import locationReducer, { MapGeolocationAction } from './location';
import { MapMeasurementAction, measurementReducer } from './measurement';
import searchReducer, { MapSearchAction } from './search';
import selectedReducer, { MapSelectedAction } from './selected';
import traceReducer, { MapTraceAction } from './trace';

export type MapAction =
  | MapDrawAction
  | MapGeolocationAction
  | MapLayersAction
  | MapMeasurementAction
  | MapSearchAction
  | MapSelectedAction
  | MapTraceAction;

export default function mapReducer(state: MapState, action: MapAction): MapState {
  return {
    draw: drawReducer(state.draw, action as MapDrawAction),
    layers: layersReducer(state.layers, action as MapLayersAction),
    location: locationReducer(state.location, action as MapGeolocationAction),
    measurement: measurementReducer(state.measurement, action as MapMeasurementAction),
    search: searchReducer(state.search, action as MapSearchAction),
    selected: selectedReducer(state.selected, action as MapSelectedAction),
    trace: traceReducer(state.trace, action as MapTraceAction),
  };
}
